<h3>
    <span ng-bind-html="item.Title|cHighlight:highlight"></span>
</h3>
<c-property-list properties="item.itemProperties" highlight="highlight"></c-property-list>
